/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { CircularProgress, Fab } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles()((theme) => ({
  premiumButton: {
    backgroundColor: '#0fd27a !important',
    color: 'white',
    padding: '28px !important',
    marginTop: '5px',
    marginBottom: '5px',
    borderRadius: '30px !important',
    boxShadow: '0 2px 1px 1px hsla(0, 0%, 17%, 0.22)',
    width: '100% !important',
    fontSize: '16px',
    [theme.breakpoints.down('md')]: {
      height: '60px !important',
      borderRadius: '5px !important',
      padding: '0 10px !important',
    },
    '&:hover': {
      backgroundColor: '#0ebd6e !important',
    },
  },
  premiumButtonSmall: {
    backgroundColor: '#0fd27a !important',
    color: 'white',
    padding: '15px !important',
    marginTop: '5px',
    marginBottom: '5px',
    borderRadius: '30px !important',
    boxShadow: '0 2px 1px 1px hsla(0, 0%, 17%, 0.22)',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      height: '60px !important',
      borderRadius: '5px !important',
    },
    '&:hover': {
      backgroundColor: '#0ebd6e !important',
    },
  },
}));

// COMPONENT
function GetPremiumButton({ label, onClick, isLoading, small }) {
  const { classes } = useStyles();
  return (
    <Fab
      variant="extended"
      size="medium"
      color="primary"
      aria-label="obter premium"
      className={small ? classes.premiumButtonSmall : classes.premiumButton}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <CircularProgress size={40} style={{ color: 'white' }} thickness={5} />
        </>
      ) : (
        <>
          <FontAwesomeIcon icon="crown" size="1x" fixedWidth color="white" style={{ marginRight: '10px' }} />
          {label}
        </>
      )}
    </Fab>
  );
}

GetPremiumButton.defaultProps = {
  small: false,
};

export default GetPremiumButton;
